const FALLBACK = '/today-mission';
const DANGEROUS_PATHS = ['/auth/logout'];

export function sanitizeReturnUrl(raw: string | null | undefined): string {
  if (!raw) return FALLBACK;

  // 1. backslash 정규화 (IE/Edge compat 공격 벡터)
  let url = raw.replace(/\\/g, '/');

  // 2. protocol-relative URL 차단 (//)
  if (url.startsWith('//')) return FALLBACK;

  // 3. 절대 경로만 허용 (scheme 포함 URL 차단)
  if (!url.startsWith('/')) return FALLBACK;

  // 4. URL 파서로 호스트 검증
  try {
    const parsed = new URL(url, 'http://localhost');
    if (parsed.hostname !== 'localhost') return FALLBACK;
  } catch {
    return FALLBACK;
  }

  // 5. encoded slash 차단 (%2F, %5C)
  if (/%2f/i.test(raw) || /%5c/i.test(raw)) return FALLBACK;

  // 6. 위험 경로 차단
  if (DANGEROUS_PATHS.some((p) => url.startsWith(p))) return FALLBACK;

  return url;
}
